// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iX8u","right":"styles_right__37Qfu"};